const merchantDetailsLabel = (value1, value2, type, monthYear) => {
  let displayValue;
  const displayLabel = 'Txn / GMV';
  let month;
  let fullYear;
  if (monthYear) {
    const dateObj = new Date(monthYear);
    month = dateObj.toLocaleString('default', { month: 'long' });
    fullYear = dateObj.getFullYear();
  }
  switch (type) {
    case 'highest':
      displayValue = `Highest month / ${displayLabel}`;
      break;
    case 'lm':
      displayValue = `Last month ${displayLabel}`;
      break;
    case 'p2p_lm':
      displayValue = `Last month P2P ${displayLabel}`;
      break;
    case '3p_lm':
      displayValue = `Last month 3P ${displayLabel}`;
      break;
    case 'mtd':
      displayValue = `MTD ${displayLabel}`;
      break;
    case 'days':
      displayValue = 'Transaction Days LM / MTD';
      break;
    // This case is for the value of highest month/ gmv/ txn
    case 'highest_value':
      if (!monthYear && !value1 && !value2) {
        displayValue = 'Not Available';
      } else {
        displayValue = `${
          monthYear ? `${month} ${fullYear} / ` : 'Not available / '
        } ${value1 ? `${value1} / ` : 'Not available / '} ${
          value2 ? `${value2} / ` : 'Not available'
        }`;
      }
      break;
    default:
      if (!value1 && !value2) {
        displayValue = 'Not Available';
      } else {
        displayValue = `${value1 ? `${value1} / ` : 'Not available / '} ${
          value2 ? `${value2} / ` : 'Not available'
        }`;
      }
  }
  return displayValue.trim().replace(/\/$/, '');
};
export default merchantDetailsLabel;
